import { Div } from "../../../base/components/native/div"
import * as styles from "./progress-bar.style"

export const ProgressBar = () => {
    const base = Div()
    base.cssClass(styles.baseStyle)

    const placeholder = Div()
    placeholder.cssClass(styles.placeholderStyle)
    base.append(placeholder)

    const fill = Div()
    fill.cssClass(styles.fillStyle)
    placeholder.append(fill)

    const text = Div()
    text.cssClass(styles.textStyle)
    base.append(text)

    return Object.assign(base, {
        setProgress: (progress: number) => {
            base.style({ opacity: '1' })
            fill.style({ width: `${progress}%` })
            text.html(`${progress}%`)
        }
    })
}